import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopBar } from './src/components/TopBar';
import { HeroSection } from './src/components/HeroSection';
import { MultiStepForm } from './src/components/MultiStepForm';
import { LegalFooter } from './src/components/LegalFooter';
import { ThankYouPage } from './src/pages/ThankYouPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    document.title = 'The Founders Law';
    // Meta Pixel initialization
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '290783800709534');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<div className="min-h-screen bg-navy flex flex-col relative" data-id="element-3">
              <TopBar data-id="element-4" />
              <main className="flex-1" data-id="element-5">
                <HeroSection data-id="element-6" />
                <MultiStepForm data-id="element-7" />
              </main>
              <LegalFooter data-id="element-8" />
              <noscript data-id="element-9">
                <img height="1" width="1" style={{
            display: 'none'
          }} src="https://www.facebook.com/tr?id=290783800709534&ev=PageView&noscript=1" alt="" data-id="element-10" />
              </noscript>
            </div>} data-id="element-2" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-12" />} data-id="element-11" />
      </Routes>
    </BrowserRouter>;
}